import { useQuery } from '@tanstack/react-query'
import { fetchPreferences } from '@app/services/legendService'
import { useAtomValue } from 'jotai'
import { clientNameAtom } from '@app/state/clientsAtom'

export interface PreferencesTypes {
  term_preference: { risk: boolean; hazard: boolean }
  use_hazard_name: { flag: boolean }
  basemap_list: { source: string; label: string; type: string }[]
}

const default_preferences: PreferencesTypes = {
  term_preference: { risk: false, hazard: false },
  use_hazard_name: { flag: false },
  basemap_list: [],
}

export const usePreferences = () => {
  const clientName = useAtomValue(clientNameAtom)
  const { data, isLoading, isError, error } = useQuery<PreferencesTypes>({
    queryKey: ['preferences', clientName],
    queryFn: fetchPreferences,
    staleTime: 2000 * 60 * 10,
  })

  const preferences = data ?? default_preferences

  return {
    ...preferences,
    isLoading,
    isError,
    error,
  }
}
